import { Injectable } from '@angular/core';
import { HttpClientService } from './../httpClient/httpclient.service';
import { AuthService } from '../user/auth.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Rx';
import { ListMetadata } from 'app/models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';
import { LoyaltyCatalogCategoryGift } from 'app/models/loyalty-catalog-category-gift';

@Injectable()
export class LoyaltyCatalogCategoryService {


  cachedCategoryGift: Observable<LoyaltyCatalogCategoryGift>

  private baseUrl = 'koncentro-promo/catalog-gift/category';

  categoryGift: LoyaltyCatalogCategoryGift[];
  categoryGiftEdit: LoyaltyCatalogCategoryGift;

  constructor(
    private http: HttpClientService,
    private message: MessageService
  ) { }

  /**
  * Tramite GET carico i campi del dto di CategoryGift in un Observable
  * @returns il dto CategoryGift
  */
  getCategoryGift() {
    if (!this.cachedCategoryGift) {
      this.cachedCategoryGift = this.http.get(`koncentro-promo/schema/CategoryGiftDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCategoryGift;
  }

  getCategoryGifts() {
    return this.http.get(`${this.baseUrl}`);
  }

  /**
  * Tramite metodo GET, restituisce la lista delle Query importati.
  * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<LoyaltyCatalogCategoryGift>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/?` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  /**
  * Tramite metodo POST, crea una nuova categoryGift
  * @param newData i dati del categoryGift da creare
  * @return un messaggio di oprezione avvenuta con successo
  */
  post(newData) {
    return this.http.post(`${this.baseUrl}/`, newData)
    .map(res => {
      newData.id = res.id;
      Object.assign(this.categoryGiftEdit, newData)
      //this.categoryGift.push(newData);
      //this.message.add({severity: 'info', summary: 'Success', detail: 'Operation success'})
      //publishReplay(1), // this tells Rx to cache the latest emitted
      //refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
    })
  }

  /**
   * Tramite metodo PUT, modifica/aggiorna un categoryGift
   * @param newData i dati del categoryGift
   * @param id l'id del record
   * @return un messaggio di operazione avvenuta con successo
   */
  put(newData, id) {
    return this.http.put(`${this.baseUrl}/` + id, newData)
      .map(res => {
        Object.assign(this.categoryGiftEdit, newData)
        //this.message.add({severity: 'info', summary: 'Success', detail: 'Operation success'})
      })
  }

  /**
   * Tramite metodo DELETE, elimina logicamente un categoryGift
   * @param id l'id del record
   * @returns un messaggio di operazione avvenuta con successo
   */
  delete(id) {
    return this.http.delete(`${this.baseUrl}/` + id);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-catalog-category.service.ts